<template>
  <RF-Dialog
    :cpntStatus='statusGeral'
    :cpntLargura='"800px"'

    :cpntOnFecharDialog='proFormEstAjusteFechar'>
    <template slot='titulo'>
      <!-- SETA O ICONE DO CAMPO -->
      <i aria-hidden="true" class="fa fa-angle-double-right"></i>

      <!-- SETA O TITULO DA ABA -->
      Ajuste de estoque do produto
    </template>

    <template slot='conteudo'>
      <div class="pro-form-est-ajuste">
        <App-Button :cpntClass="'btn btn-primary btn-sm'" @onClick="() => { proFormEstoqueAjustarEstoque({ id: '0' }) }">
          Novo ajuste de estoque
        </App-Button>

        <App-Tabela
        :cpntCheckbox="checkbox"
        :cpntColuna="colunas"
        :cpntLinha="linhas"

        :cpntMostrarMper="true"
        :cpntApiTabPerFiltros="false"
        :cpntApiTabPerOrder="tabPerOrder"
        :cpntApiTabPer="tabper"

        :cpntBotaoExportar="exportar"
        :cpntBotaoExcluir="botaoExcluir"
        :cpntBotaoEditar="botaoEditar"
        :cpntSetarValores="proGerTabSetarLinhas"
        :cpntApiRouter="route"
        :cpntApiWhere="where"
        :cpntApiOrder="order"
        :cpntApiField="field"
        :cpntApiFieldVirtual="fieldVir"
        :cpntApiMethods="'POST'"
        :cpntApiEstruturaQueryGet="estruturaQueryGet"
        @TABELA_MARCAR_CHECKBOX='proGerTabMarcarCheckbox'
        ref="tabela">
        <!-- COLUNA VALOR -->
        <template v-slot:valor="{ linha, indexCV }">
          <span v-if="[ '', null, undefined, '0', 0 ].indexOf(linha['_' + indexCV]) !== -1" v-html="'---'"></span>
          <span v-else v-html="linha['_' + indexCV]"></span>
        </template>
        
        <!-- COLUNA ULTIMA ALTERAÇÃO -->
        <template v-slot:col_last="{ linha }">
          <template v-if="[ '', null, undefined ].indexOf(linha.last_user) === -1">
            <span v-html="linha.last_user_usuario + '<br/>' + linha.last_at_ptbr"></span>
          </template>
        </template>
        <template>
          ---
        </template>
        </App-Tabela>
      </div>

      <App-Produto-Formulario-Estoque-Ajuste-Novo v-if="[ '', null, undefined ].indexOf(novoAjuste) === -1"
      :cpntHashId="cpntHashId"
      :cpntIdPro="cpntId"
      :cpntId="novoAjuste.id"
      :cpntDados="novoAjuste"
      :cpntProduto="cpntDados"
      :cpntFecharFormulario="proFormEstoqueAjustarEstoque"
      @ATUALIZAR_INFORMACOES_EXTERNAS="() => { proFormAtualizarInfoExterna() }"
      @PRODUTO_AJUSTE_ESTOQUE="proFormEstoqueAjustarSalvar"
      ref="formulario"
      ></App-Produto-Formulario-Estoque-Ajuste-Novo>
    </template>
  </RF-Dialog>
</template>

<style scoped>
  .pro-form-est-ajuste > button {
    margin-bottom: 5px;
  }
</style>

<style>
</style>

<script>
  export default {
    props: {
      cpntHashId: {
        required: true
      },
      cpntId: {
        required: true
      },
      cpntEditarVarios: {
        required: true
      },
      cpntDados: {
        required: false,
        default: function () {
          return {}
        }
      },
      cpntValorAjusteNovo: {
        required: false,
        default: function () {
          return null
        }
      },

      cpntFecharFormulario: {
        required: true
      }
    },
    components: {
      'App-Produto-Formulario-Estoque-Ajuste-Novo': () => import('@/components/produto/gerenciar/Formulario/Produto-Formulario-Estoque-Ajuste-Novo.vue')
    },
    data: function () {
      return {
        time: '',
        statusGeral: 'carregando',
        novoAjuste: { id: 0 },
        checkbox: [],
        tabper: 'EstoqueAjuste',
        route: '/produto/estoque/ajuste/get',
        colunas: [],
        linhas: [],
        field: {},
        fieldVir: [],
        where: {},
        order: {},
        estruturaQueryGet: [
          [ 'type', 'countAll', 'limit', 'field', 'field_virtual', 'where', 'order' ]
        ],
        botaoEditar: undefined,
        botaoExcluir: undefined,
        exportar: undefined,
        tabPerOrder: [
          { id: '0', nome: 'Estoque Data Movimento Decrescente',       chave: 'last_at',  order: 'desc' },
          { id: '1', nome: 'Estoque Data Movimento Crescente',         chave: 'last_at',  order: 'asc' },
          { id: '2', nome: 'Última Alteração Decrescente',             chave: 'last_at',  order: 'desc' },
          { id: '3', nome: 'Última Alteração Crescente',               chave: 'last_at',  order: 'asc' }
        ],
      }
    },
    mounted: function () {
      this.proFormEstAjusteIniciar()
    },
    methods: {    
      proFormEstAjusteFechar: function (atualizar) {
        this.cpntFecharFormulario(atualizar)
      },
      proFormEstAjusteIniciar: function () {
        // LIMPA A VARIAVEL
        this.conferencia = []

        // INICIA A VARIAVEL DOS BOTÕES
        this.botaoEditar = this.proFormEstAjusteEditarRegistro
        this.botaoExcluir = this.proFormEstAjusteExcluirRegistro
        this.exportar = null

        // SETA O WHERE QUE DEVE REALIZAR
        this.where = { aAnd: [ { f: 'status', o: '=', v: '1' }, { f: 'id_pro', o: '=', v: this.cpntId } ] }

        // SETA AS COLUNAS DA TABELA
        var colunas = [
          { mPer: 3,   chave: 'id',                            tipo: 'checkbox'                         },
          { mPer: 1,   chave: 'id',                            nome: 'Cód.'                             },
          { mPer: 1,   chave: 'qtde_ajuste',                   nome: 'Qtde Ajuste',       slot: 'valor' },
          { mPer: 1,   chave: 'valor_unitario',                nome: 'Valor Unitario',    slot: 'valor' },
          { mPer: 1,   chave: 'valor_total',                   nome: 'Valor Total',       slot: 'valor' },
          { mPer: 1,   chave: 'observacao',                    nome: 'Observação'                       },
          { mPer: 1,   chave: 'estoque_data_movimento_ptbr',   nome: 'Estoque Data Movimento'           },
          { mPer: 1,   chave: 'last',                          nome: 'Última Alteração'                 }
        ]

        // SETA OS CAMPOS QUE DEVE BUSCAR
        this.field = {
          id: null,
          qtde_ajuste: null,
          valor_unitario: null,
          valor_total: null,
          observacao: null,
          estoque_data_movimento: null,
          last_user: { j: { usuario: null } },
          last_at: null
        }

        // // REMOVE AS COLUNAS INFORMADAS
        // if (remover.length >= 1) {
        //   colunas = colunas.filter(item => remover.indexOf(item.chave) === -1)
        // }

        // SETA AS COLUNAS MONTADAS
        this.colunas = colunas

        // VERIFICA SE TEM QUE BUSCAR E ATUALIZAR A TABELA       
        if ([ '', null, undefined ].indexOf(this.$refs.tabela) === -1 && this.statusGeral === '') {
          this.proGerTabReiniciar()
        } else {
          // SETA O STATUS DA PAGINA
          this.proGerTabSetarStatusGeral('')

          // VERIFICA SE TEM DADOS PARA INCIAR A TABELA
          if (this.cpntValorAjusteNovo !== null) {
            setTimeout(() => {
              // PEGA OS DADOS E TRATA PARA INSERIR NA TABELA
              var linha = JSON.parse(JSON.stringify(this.cpntValorAjusteNovo))

              // SETA O ID DO FORMULARIO
              if ([ '', null, undefined ].indexOf(linha.id) !== -1) {
                linha.id = '0'
              }

              // SETA A DATA MOVIEMNTO O CAMPO
              if ([ '', null, undefined ].indexOf(linha.estoque_data_movimento) === -1) {
                linha.estoque_data_movimento_ptbr = linha.estoque_data_movimento.replace(' ', ' às ')
              }
    
              // SETA O VALOR TOTAL
              linha.valor_total = (Number(linha.qtde_ajuste) * Number(linha.valor_unitario)).toString()
    
              // SETA A LINHA NA TABELA DESEJADA
              this.proGerTabSetarLinhas([ linha ], false)
            }, 500)
          }
        }
      },
      proGerTabSetarStatusGeral: function (status) {
        // SETA O STATUS DA TELA
        this.statusGeral = status

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()
      },
      proFormEstAjusteExcluirRegistro: function () {
        if (this.checkbox.length === 0) {
          this.$store.state.msgWarn('WEB [406]: Selecione ao menos um registro para editar.', 'warning')
        } else if (window.confirm('Deseja realmente excluir o(s) registro(s) selecionado(s)?')) {
          // SETA O STATUS DE CARREGANDO PARA O BOTÃO
          this.botaoExcluir = 'carregando'

          // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
          this.time = new Date().getTime()

          // INICIA O FORMULARIO
          var formData = []

          // ADICIONA OS VALORES NA TABELA
          for (var index in this.checkbox) {
            formData.push({ id: this.checkbox[index] })
          }

          // CONVERTE EM LOT A CHAVE
          formData = { lot: formData }

          // CHAMA FUNÇÃO PARA COMUNICAR COM API
          this.$store.state.comunicaAPI('/produto/estoque/ajuste', 'DELETE', formData, (retorno) => {
            // PEGA O RETORNO RECEBIDO 
            retorno = retorno.lot[0]

            // VERIFICA O RESULTADO DA OPERAÇÃO
            switch (retorno.code) {
              case '200':
                // LIMPA OS CHECKBOX SELECIONADOS
                this.checkbox = []

                // APRESENTA A MENSAGEM DE SUCESSO
                this.$store.state.TRATAR_RET_LOT_API(retorno)

                // SETA COM A ATUALIZAÇÃO 
                this.proFormAtualizarInfoExterna()
                break

              default:
                this.$store.state.TRATAR_RET_LOT_API(retorno)
                break
            }

            // SETA O STATUS DE CARREGANDO PARA O BOTÃO
            this.botaoExcluir = this.proFormEstAjusteExcluirRegistro

            // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
            this.time = new Date().getTime()
          }, this.proGerTabSetarStatusGeral)
        }
      },
      proFormEstAjusteEditarRegistro: function () {
        if (this.checkbox.length === 0) {
          this.$store.state.msgWarn('WEB [406]: Selecione ao menos um registro para editar.', 'warning')
        } else if (this.checkbox.length > 1) {
          this.$store.state.msgWarn('WEB [406]: Selecione apenas um registro para editar.', 'warning')
        } else {
          // PEGA A LINHA DE DADOS
          var linha = this.linhas.filter(item => item.id.toString() === this.checkbox[0].toString())

          // SETA OS DADOS SOLICITADOS
          this.proFormEstoqueAjustarEstoque(linha[0])
        }
      },
      proGerTabReiniciar: function (tentativa = 0) {
        if (tentativa <= 5) {
          if ([ '', null, undefined ].indexOf(this.$refs.tabela) === -1 && [ '', null, undefined ].indexOf(this.$refs.tabela.cpntTabelaReiniciar) === -1) {
            // INICIA A VARIAVEL
            this.linhas = []

            // EXECUTA A FUNÇÃO DE REINICIALIZAR
            this.$refs.tabela.cpntTabelaReiniciar()
          } else {
            setTimeout(() => { this.proGerTabReiniciar((tentativa + 1)) }, 100)
          }
        }
      },
      proGerTabSetarLinhas: function (vetor, zerar = true) {
        // INICIA A VARIAVEL
        if (zerar === true) {
          this.linhas = []
        }

        // SETA OS IDS SOLICITADOS
        for (var index in vetor) {
          // vetor[index]._qtde_ajuste = this.$store.state.FUN_MASK_VALOR('valorDecimalNovo', vetor[index].qtde_ajuste)
          vetor[index]._qtde_ajuste = this.$store.state.FUN_MASCARA_VALOR('VALOR_DECIMAL_FRONT', vetor[index].qtde_ajuste)
          vetor[index]._valor_unitario = this.$store.state.FUN_MASK_VALOR('valorDecimalNovo', vetor[index].valor_unitario)
          vetor[index]._valor_total = this.$store.state.FUN_MASK_VALOR('valorDecimalNovo', vetor[index].valor_total)
        }

        // SETA OS VALORES RECEBIDOS
        this.linhas = this.linhas.concat(vetor)

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()
      },
      proGerTabMarcarCheckbox: function (checked, value) {
        // VERIFICA A AÇÃO QUE DEVE REALIZAR COM OS CHECKBOXS
        switch (checked) {
          case true:
            this.checkbox.push(value)
            break

          case false:
            this.checkbox = this.checkbox.filter(item => item !== value)
            break
        }

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()
      },
      proFormEstoqueAjustarEstoque: function (valor) {
        // SETA ATUALIZAÇÃO
        var atualizar = typeof valor === 'boolean'

        // SETA SE DEVE ABRIR OU FECHAR A TELA DE AJUSTAR ESTOQUE
        this.novoAjuste = atualizar === true ? null : valor

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()

        // // VERIFICA SE DEVE ATUALIZAR
        // if (atualizar === true) {
        //   setTimeout(() => { this.proFormEstoqueAjustarEstoque({ id: 0 }) }, 100)
        // }
      },
      proFormEstoqueAjustarSalvar: function (formData) {
        // PEGA OS DADOS E TRATA PARA INSERIR NA TABELA
        var linha = JSON.parse(JSON.stringify(formData))

        // SETA O ID DO FORMULARIO
        if ([ '', null, undefined ].indexOf(linha.id) !== -1) {
          linha.id = '0'
        }

        // SETA A DATA MOVIEMNTO O CAMPO
        if ([ '', null, undefined ].indexOf(linha.estoque_data_movimento) === -1) {
          linha.estoque_data_movimento_ptbr = linha.estoque_data_movimento.replace(' ', ' às ')
        }

        // SETA O VALOR TOTAL
        linha.valor_total = (Number(linha.qtde_ajuste) * Number(linha.valor_unitario)).toString()

        // SETA A LINHA NA TABELA DESEJADA
        this.proGerTabSetarLinhas([ linha ], false)

        // MANDA O VALOR PARA FRENTE
        this.$emit('PRODUTO_AJUSTE_ESTOQUE', formData)
      },
      proFormAtualizarInfoExterna: function () {
        // CHAMA A FUNÇÃO PARA INICIAR O PROCESSO
        this.proFormEstAjusteIniciar()

        // SETA COM A ATUALIZAÇÃO 
        this.$emit('ATUALIZAR_INFORMACOES_EXTERNAS')
      }
    }
  }
</script>
